import { render, staticRenderFns } from "./MetadataEditor.vue?vue&type=template&id=1f1e2f53&scoped=true"
import script from "./MetadataEditor.vue?vue&type=script&lang=js"
export * from "./MetadataEditor.vue?vue&type=script&lang=js"
import style0 from "./MetadataEditor.vue?vue&type=style&index=0&id=1f1e2f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e2f53",
  null
  
)

export default component.exports